import { useQuery } from '@apollo/client';
import { getClinicianAddressState } from 'clinician/helpers';
import { CareTeamPhysiciansQuery } from 'clinician/Schema';
import { useMemo } from 'react';
import { getTimezoneNameByState } from 'utility/helpers';

export const useClinicianTimeZone = (practitionerId: string) => {
  const { data: clinicianData } = useQuery(CareTeamPhysiciansQuery, {
    skip: !practitionerId,
    fetchPolicy: 'cache-and-network',
    variables: {
      first: 1,
      search: {
        id: practitionerId,
      },
    },
  });
  const clinicianTimeZone = useMemo(() => {
    const state = getClinicianAddressState(
      clinicianData?.CareTeamPhysicians?.edges?.[0]?.node
    );
    const timeZone = getTimezoneNameByState(state || '');
    return timeZone;
  }, [clinicianData, practitionerId]);
  return clinicianTimeZone;
};
